<template>
    <div>
        <div v-if="loading > 0">
            <vue-progress-bar></vue-progress-bar>
            <div class="bg"></div>
        </div>
    </div>
</template>

<script>
    import {mapState} from 'vuex';
    export default {
        name: "loaderPage",
        computed:{
            ...mapState(['loading'])
        }
    }
</script>

<style scoped>
    .bg{
        background-color: rgba(255, 255, 255, 0.2);
        position: fixed;
        width: 100%;
        height: 100vh;
        z-index: 99999;
        cursor: wait;
    }
</style>